import React, { useState } from "react";
import img from "../../assets/about.png";
import { FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa6";
import { Link } from "react-router-dom";
import emailjs from '@emailjs/browser';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatus("Sending...");

//     try {
//       const response = await fetch("https://localhost/abadmin/api/send-mail.php", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(formData),
//       });

//       if (response.ok) {
//         setStatus("Message sent successfully!");
//         setFormData({ name: "", email: "", subject: "", message: "" });
//       } else {
//         setStatus("Failed to send message. Please try again.");
//       }
//     } catch (error) {
//       setStatus("An error occurred. Please try again.");
//     }
//   };

const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('Sending');

    emailjs
        .send(
            'service_9xf00en', // Replace with your EmailJS service ID
            'template_zilukc5', // Replace with your EmailJS template ID
            formData,
            'f8S7qy3MbfADsf7f_' // Replace with your EmailJS user ID
        )
        .then(
            () => {
                setStatus('Message sent successfully!');
                setFormData({ name: '', email: '', subject: '', message: '' }); // Reset form
            },
            (error) => {
                console.error(error);
                setStatus('Failed to send the message. Please try again later.');
            }
        );
};
  return (
    <div className="md:py-[100px] py-[40px]" id="contact">
      <div className="max-w-[1400px] 2xl:mx-auto mx-4 relative">
        <div className="flex md:flex-row flex-col bg-[#0788ff33] border-[#0788ff33] border rounded-lg p-8">
          <div>
            <div className="gradul h-[300px] overflow-hidden rounded-lg">
              <img className="w-[264px]" src={img} alt="" />
            </div>
            <div className="mt-12">
              <p className="text-darklight uppercase">Write an Email</p>
              <Link
                to="mailto:contact@mabubakaransari.com"
                target="_blank"
                className="text-xl underline"
              >
                contact@mabubakaransari.com
              </Link>
            </div>
            <div className="mt-4">
              <p className="text-darklight uppercase">Whatsapp</p>
              <Link
                to="https://wa.me/+92116423558"
                target="_blank"
                className="text-xl underline"
              >
                +92 3116423558
              </Link>
            </div>
            <div className="flex items-center gap-4 mt-12">
              <Link
                target="_blank"
                to="https://www.facebook.com/m.abubakaransari6"
                className="bg-blue-500 border-2 border-white hover:-translate-y-2 duration-300 shadow-lg active:-translate-y-0 hover:shadow-secondary p-4 rounded-full text-2xl"
              >
                <FaFacebookF />
              </Link>
              <Link
                target="_blank"
                to="https://www.instagram.com/abubakaransari3932/"
                className="bg-pink-600 border-2 border-white hover:-translate-y-2 duration-300 shadow-lg active:-translate-y-0 hover:shadow-secondary p-4 rounded-full text-2xl"
              >
                <FaInstagram />
              </Link>
              <Link
                target="_blank"
                to="https://www.linkedin.com/in/muhammad-abu-bakar-982007338/"
                className="bg-sky-400 border-2 border-white hover:-translate-y-2 duration-300 shadow-lg active:-translate-y-0 hover:shadow-secondary p-4 rounded-full text-2xl"
              >
                <FaLinkedinIn />
              </Link>
            </div>
          </div>
          <div className="md:flex-1 md:mt-0 mt-12 md:p-8">
            <div className="rounded-t-lg">
              <div className="">
                <h4 className="text-4xl font-semibold ">
                  Let’s Discuss Your Project
                </h4>
                <p className="text-darklight">
                  Always available for freelancing if the right project comes
                  along, Feel free to contact me.
                </p>
                <p className={status==='Sending'?'text-red-600 text-md font-medium':'text-green-600 text-md font-medium'}>{status}</p>
              </div>
            </div>
            <form onSubmit={handleSubmit} className="rounded-b-lg md:mt-8 mt-4">
              <div className="flex md:flex-row flex-col gap-2">
                <div className="w-full">
                  <p className="uppercase mb-1">Your Name</p>
                  <input
                    className="w-full outline-none bg-[#ffffff0d] py-2 px-4 rounded-lg border border-[#ffffff26]"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Name *"
                    required
                  />
                </div>
                <div className="w-full">
                  <p className="uppercase mb-1">Your Email</p>
                  <input
                    className="w-full outline-none bg-[#ffffff0d] py-2 px-4 rounded-lg border border-[#ffffff26]"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email *"
                    required
                  />
                </div>
              </div>
              <div className="w-full">
                <p className="uppercase mb-1">Subject</p>
                <input
                  className="w-full outline-none bg-[#ffffff0d] py-2 px-4 rounded-lg border border-[#ffffff26]"
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Subject *"
                  required
                />
              </div>
              <div className="w-full">
                <p className="uppercase mb-1">Your Message</p>
                <textarea
                  rows={10}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  className="w-full outline-none bg-[#ffffff0d] py-2 px-4 rounded-lg border border-[#ffffff26]"
                  placeholder="Your Message *"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-secondary py-3 text-center rounded-full uppercase font-semibold"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
